module.exports = "<path d=\"M19,10 L15,10 L15,4 L9,4 L9,10 L5,10 L12,17 L19,10 L19,10 Z M5,19 L5,21 L19,21 L19,19 L5,19 L5,19 Z\"/>"